<template>
  <div class="app-cancellation-success">
    <slot name="txtBefore">Lieber Vodafone Kunde/ liebe Vodafone Kundin,</slot>
    <dyn-slot :slot-data="slotData">
      <slot name="txtDesc">
        <div>Ihre Kündigungserklärung ist am <strong>{{ formatDate(getCancellationData.createdAt) }}</strong> um <strong>{{ formatTime(getCancellationData.createdAt) }}</strong> Uhr bei uns eingegangen. Ihren Auftrag prüfen wir. Aus datenschutzrechtlichen Gründen, senden wir die weitere Kommunikation an die bei uns im System hinterlegte verifizierte E-Mail-Adresse oder Postanschrift des Vertragsinhabers.
        </div>
      </slot>
    </dyn-slot>
    <div class="summary">
      <slot name="txtBeforeSummary">Ihre Angaben:</slot>
      <b-row class="firstName">
        <b-col class="label col-4">
          <slot name="labelFirstName">Vorname:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="firstName">{{getCancellationData.address.firstName}}</span>
        </b-col>
      </b-row>
      <b-row class="lastName">
        <b-col class="label">
          <slot name="labelLastName">Nachname:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="lastName">{{getCancellationData.address.lastName}}</span>
        </b-col>
      </b-row>
      <b-row class="street">
        <b-col class="label  col-4">
          <slot name="labelStreet">Straße:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="street">{{getCancellationData.address.street}}</span>
        </b-col>
      </b-row>
      <b-row class="houseNumber">
        <b-col class="label  col-4">
          <slot name="labelHouseNumber">Hausnummer:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="houseNumber">{{getCancellationData.address.houseNumber}}</span>
        </b-col>
      </b-row>
      <b-row class="zip">
        <b-col class="label  col-4">
          <slot name="labelZip">Postleitzahl:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="zip">{{getCancellationData.address.zip}}</span>
        </b-col>
      </b-row>
      <b-row class="city">
        <b-col class="label  col-4">
          <slot name="labelCity">Stadt:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="city">{{getCancellationData.address.city}}</span>
        </b-col>
      </b-row>
      <b-row class="email">
        <b-col class="label  col-4">
          <slot name="labelEmail">E-Mail-Adresse:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="email">{{getCancellationData.customer.email}}</span></b-col>
      </b-row>
      <b-row class="customerID">
        <b-col class="label  col-4">
          <slot name="labelCustomerID">Kundennummer:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="customerId">{{getCancellationData.customer.terminationId.customerId}}</span>
        </b-col>
      </b-row>
      <b-row class="contractID">
        <b-col class="label  col-4">
          <slot name="labelContractID">Vertragsnummer:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="contractId">{{getCancellationData.customer.terminationId.msisdnOrContractId}}</span>
        </b-col>
      </b-row>
      <b-row class="preferredCancellationDate">
        <b-col class="label  col-4">
          <slot name="labelCancellationDate">Gewünschter Kündigungstermin:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="cancelDate">{{getCancellationData.customer.terminationData.date}}</span>
        </b-col>
      </b-row>
      <b-row class="details">
        <b-col class="label  col-4">
          <slot name="labelDetails">Details zur Kündigung:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="details">{{getCancellationData.customer.terminationData.details}}</span>
        </b-col>
      </b-row>
      <b-row class="transactionNumber">
        <b-col class="label  col-4">
          <slot name="labelTransactionNumber">Vorgangsnummer:</slot>
        </b-col>
        <b-col class="value col-8">
          <span class="transactionNumber">{{getCancellationData.caseNumber}}</span>
        </b-col>
      </b-row>
    </div>
    <div class="document-link">
      <p>Die Kündigungserklärung als <slot name="PDF">PDF</slot> <a @click="download()" target="_blank">herunterladen</a>.</p>
    </div>
    <slot name="txtAfter"></slot>
    <Stepper
      @prev="back()"
      :show-next="false"
    >
      <template #btnPrev><slot name="btnBack">zurück</slot></template>
    </Stepper>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import Stepper from '@/components/generic/Stepper.vue'
import FileSaver from 'file-saver'

export const stepName = 'cancellationSuccess'

export default {
  name: 'CancellationSuccess',
  components: {
    Stepper
  },
  mixins: [
  ],
  methods: {
    ...mapMutations('cancel', [
      'changeStep'
    ]),
    back () {
      this.changeStep(this.previousStep)
    },
    formatDate (dateTimeString) {
      const d = new Date(dateTimeString)
      return (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + '.' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '.' + d.getFullYear()
    },
    formatTime (dateTimeString) {
      const d = new Date(dateTimeString)
      return (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds())
    },
    download: function () {
      const decodedDocumentPdf = Uint8Array.from(atob(this.getCancellationData.document.document), c => c.charCodeAt(0))
      const file = new Blob([decodedDocumentPdf], { type: this.getCancellationData.document.type['content-type'] })
      FileSaver.saveAs(file, 'Kündigungserklärung.pdf')
    }
  },
  props: {
    previousStep: {
      type: String,
      default: 'cancellationForm'
    }
  },
  computed: {
    ...mapGetters('cancel', ['getCancellationData']),
    slotData () {
      return {
        cancellationDate: this.formatDate(this.getCancellationData.createdAt),
        cancellationTime: this.formatTime(this.getCancellationData.createdAt)
      }
    }
  }
}
</script>
